module.exports = __webpack_public_path__ + "img/Harvest-Hosts.458382d1.png";